
import { defineComponent, inject } from 'vue';
import { useVModel } from 'vue-composable';
import { WarningOutline as WarningIcon } from '@vicons/ionicons5';
import surveyService from '@/services/survey-service';
import { Survey } from '@/types';
import { ShowToast } from '@/providers/Toast/toast-types';

export default defineComponent({
  name: 'ConfirmsurveyDeleteModal',
  props: {
    survey: {
      type: Object as () => Survey | null,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },
  components: { WarningIcon },
  setup(props, { emit }) {
    const showModalRef = useVModel(props, 'showModal');
    const showToast = inject<ShowToast>('showToast')!;
    const confirmDelete = () => {
      if ((props.survey?.completedCount ?? 0) > 0) {
        showToast({
          headline: 'Error',
          message: 'Cannot delete a survey that has been completed',
          color: 'danger'
        });
        showModalRef.value = false;
      } else {
        surveyService
          .delete(props.survey?.id ?? '')
          .then(() => {
            emit('survey-delete', props.survey?.id ?? '');
          })
          .catch(() => {
            showToast({
              headline: 'Error',
              message: 'Failed to delete survey',
              color: 'danger'
            });
          })
          .finally(() => {
            showModalRef.value = false;
          });
      }
    };

    const cancelDelete = () => {
      showModalRef.value = false;
    };

    return {
      confirmDelete,
      cancelDelete,
      showModalRef
    };
  }
});
